export const CASES_PERMISSIONS = {
  ALL_CASES_ADMIN: 'pronetx-ticketing-admin',
  COMPANY_CASES_ADMIN: 'ticketing-admin',
  MY_CASES_READER: 'ticketing-read'
};

export const CASES_ROLES = {
  ALL_CASES_PERMISSION: 'Super Admin',
  COMPANY_CASES_PERMISSION: 'Admin',
  MY_CASES_PERMISSION: 'Customer',
  NO_ACCESS: 'No Access'
};
